import { batchGetAuthorsRequest, batchGetAuthorsResponse, followAuthorRequest, listAuthorsRequest, listAuthorsResponse } from "./authors.dto";
import { apiV2 } from "./v2";

export const listAuthorsApi = apiV2("GET", "/authors").withRequest(listAuthorsRequest).withResponse(listAuthorsResponse);

export const batchGetAuthorsApi = apiV2("POST", "/authors/batch").withRequest(batchGetAuthorsRequest).withResponse(batchGetAuthorsResponse);

export const followAuthorApi = apiV2("PUT", "/authors/:alias/followers").withRequest(followAuthorRequest);

export const unfollowAuthorApi = apiV2("DELETE", "/authors/:alias/followers").withRequest(followAuthorRequest);
